import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
} from '@angular/core';
import { BypassBlockComponent } from '@rd/core/components/bypass-block/bypass-block.component';

@Component({
  selector: 'star-bypass-block',
  templateUrl: './bypass-block.component.html',
  styleUrls: ['./bypass-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarBypassBlockComponent extends BypassBlockComponent {
  @HostBinding('class.star-core-bypass-block') componentClass = true;

  constructor(@Inject(DOCUMENT) protected document: any) {
    super(document);
  }
}
